import { SvrConn, SvrWtlss } from "../utils/axios/index";
import axios from "axios";
/**
 * metodo para traer las areas
 */
export const getCompany = async () => {
  let res = {};
  try {
    res = await SvrConn.get("/api/company/getCompany");
  } catch (Error) {
    res = Error;
  }
  return res;
};
//----------------------------------------------------------------------------------------------------------------------
export const getCompanyInt = async (TerceroId) => {
  let res = {};
  try {
    res = await SvrConn.post("/api/company/getCompanyint",{TerceroId});
  } catch (Error) {
    res = Error;
  }
  return res;
};
//----------------------------------------------------------------------------------------------------------------------
export const ActualizaCompany = async (formData) => {
  let res = {};
  try {
    res = await SvrConn.post("/api/company/setactualizacompany", formData, {
         headers: {
           "Content-Type": "multipart/form-data",
         },
       });
  } catch (Error) {
    res = Error;
  }
  return res;
};
//----------------------------------------------------------------------------------------------------------------------
export const TestCompany = async (Url, Apk, ClientId) => {
  try {
    const baseUrl = Url.trim().replace(/\/$/, "");
    if (!/^https?:\/\//i.test(baseUrl)) {
      return {
        ok: false,
        status: 0,
        message: "La URL debe iniciar con http:// o https://",
      };
    }

    const fullUrl = `${baseUrl}/app/v1/connection/test`;

    const response = await axios.get(fullUrl, {
       timeout: 10000,
       headers: {
         "X-Api-Key": String(Apk),
         "X-Client-Id": String(ClientId),
         Accept: "application/json",
        },
    });

    return {
      ok: response.status === 200,
      status: response.status,
      message: "Conexión establecida correctamente.",
    };
  } catch (error) {
    console.log("Error conexión:", error);

    return {
      ok: false,
      status: error.response?.status ?? 0,
      message:
        error.response?.data?.detail ||
        error.response?.data?.message ||
        error.message ||
        "No fue posible establecer la conexión.",
    };
  }
};